import { computed, effect, signal, Signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Params } from '@angular/router';
import { isEqual } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { missingGroupFromUrl, noGroup } from './global-variables.helper';

export function trimStrings(obj: any): any {
    if (typeof obj === 'string') {
        return obj.trim() || null;
    } else if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = trimStrings(obj[key]);
            }
        }
    }
    return obj;
}

export function getGroupIdFromUrl(url: string): number {
    if (!url) return noGroup.id;

    const pathSegments = url.split('/');
    const groupParam = pathSegments[1];

    return !Number.isNaN(Number(groupParam)) ? Number(groupParam) : missingGroupFromUrl;
}

export function getRouteWithoutQueryParamsAndGroupId(url: string): string {
    const pathSegments = url.split('?')[0].split('/');
    pathSegments.splice(1, 1);

    return pathSegments.join('/');
}

export function getRouteQueryParams(url: string): Params {
    return Object.fromEntries(new URLSearchParams(url.split('?')[1]));
}

export function behaviorToSignal<T>(behaviorSubject: BehaviorSubject<T>): Signal<T> {
    return toSignal(behaviorSubject, {
        requireSync: true,
        equal: (a, b) => {
            return isEqual(a, b);
        },
    });
}

export function linkedSignal<T>(computeFn: () => T): WritableSignal<T> {
    const internalSignal = signal<T>(computeFn());
    const computedSignal = computed(() => computeFn());

    effect(
        () => {
            internalSignal.set(computedSignal());
        },
        { allowSignalWrites: true }
    );

    return internalSignal;
}
